var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 502,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1365.03 519.255V518.085L1371.15 509.13H1364.98V507.619H1373.3V508.789L1367.18 517.744H1373.35V519.255H1365.03ZM1385.59 513.437C1385.59 514.679 1385.37 515.747 1384.91 516.641C1384.46 517.532 1383.83 518.217 1383.04 518.698C1382.25 519.175 1381.36 519.414 1380.35 519.414C1379.35 519.414 1378.45 519.175 1377.66 518.698C1376.87 518.217 1376.25 517.53 1375.79 516.636C1375.34 515.742 1375.11 514.675 1375.11 513.437C1375.11 512.194 1375.34 511.128 1375.79 510.238C1376.25 509.344 1376.87 508.658 1377.66 508.181C1378.45 507.7 1379.35 507.46 1380.35 507.46C1381.36 507.46 1382.25 507.7 1383.04 508.181C1383.83 508.658 1384.46 509.344 1384.91 510.238C1385.37 511.128 1385.59 512.194 1385.59 513.437ZM1383.85 513.437C1383.85 512.49 1383.7 511.693 1383.39 511.045C1383.09 510.393 1382.67 509.901 1382.14 509.568C1381.62 509.23 1381.02 509.062 1380.35 509.062C1379.68 509.062 1379.09 509.23 1378.56 509.568C1378.03 509.901 1377.62 510.393 1377.31 511.045C1377.01 511.693 1376.85 512.49 1376.85 513.437C1376.85 514.384 1377.01 515.183 1377.31 515.835C1377.62 516.482 1378.03 516.975 1378.56 517.312C1379.09 517.645 1379.68 517.812 1380.35 517.812C1381.02 517.812 1381.62 517.645 1382.14 517.312C1382.67 516.975 1383.09 516.482 1383.39 515.835C1383.7 515.183 1383.85 514.384 1383.85 513.437ZM1397.65 507.619V519.255H1396.04L1390.13 510.721H1390.02V519.255H1388.26V507.619H1389.89L1395.81 516.164H1395.92V507.619H1397.65ZM1400.7 519.255V507.619H1407.99V509.13H1402.45V512.675H1407.61V514.181H1402.45V517.744H1408.06V519.255H1400.7ZM1419.79 507.619V519.255H1418.02V509.38H1417.96L1415.17 511.198V509.516L1418.08 507.619H1419.79Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1392.94,
    cy: 592.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1392.94,
    cy: 592.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1392.94,
    cy: 592.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone1);
export default __webpack_public_path__ + "static/media/3d_zone_1.dcba5bbfa19cf3f23d6fc2564ba1664a.svg";
export { ForwardRef as ReactComponent };